// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes

// const useSessionTimeout = () => {
//   const navigate = useNavigate(); // ✅ Ensure this runs inside <BrowserRouter>

//   useEffect(() => {
//     let timeout: NodeJS.Timeout;

//     const logout = () => {
//       // localStorage.setItem("email", "");
//       // localStorage.setItem("isLoggedIn", "false");
//       // localStorage.setItem("manager_details", "");
//       localStorage.clear();
//       navigate("/"); // Redirect to login page
//       window.location.reload();
//     };

//     const resetTimer = () => {
//       clearTimeout(timeout);
//       timeout = setTimeout(logout, SESSION_TIMEOUT);
//     };

//     const resetSession = () => resetTimer();

//     const events = ["mousemove", "keydown", "click"];
//     events.forEach((event) => window.addEventListener(event, resetSession));

//     resetTimer(); // Start session timer

//     return () => {
//       clearTimeout(timeout);
//       events.forEach((event) =>
//         window.removeEventListener(event, resetSession)
//       );
//     };
//   }, [navigate]);

//   return null;
// };

// const SessionHandler = () => {
//   useSessionTimeout(); // ✅ Call the session timeout hook inside this component
//   return null;
// };

// export default SessionHandler;
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogoutApi } from "../../Sourcing/Services/User/Login";
import { getLoggedInUserEmail } from "../../Utils/Constant";

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

const useSessionTimeout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        let timeout: NodeJS.Timeout;

        const logout = async () => {
            try {
                const response = await LogoutApi({
                    email: getLoggedInUserEmail()
                });
                console.log("Logout response:", response);
            } catch (err) {
                console.log("error while logouting");
            } finally {
                localStorage.clear();
                sessionStorage.removeItem("isReloading"); // cleanup
                navigate("/");
                window.location.reload();
            }
        };

        const resetTimer = () => {
            clearTimeout(timeout);
            timeout = setTimeout(logout, SESSION_TIMEOUT);
        };

        const resetSession = () => resetTimer();

        const events = ["mousemove", "keydown", "click"];
        events.forEach((event) => window.addEventListener(event, resetSession));

        // Handle browser/tab close ONLY (not refresh)
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                sessionStorage.setItem("isReloading", "true");
            }
        };

        const handlePageHide = async (event: PageTransitionEvent) => {
            const isReloading = sessionStorage.getItem("isReloading");

            if (!event.persisted && isReloading !== "true") {
                // Tab or browser is closed
                try {
                    const response = await LogoutApi({
                        email: getLoggedInUserEmail()
                    });
                    console.log("Logout response:", response);
                } catch (err) {
                    console.log("error while logouting");
                } finally {
                    localStorage.clear();
                    sessionStorage.removeItem("isReloading"); // cleanup
                    navigate("/");
                    window.location.reload();
                }
            }

            // Reset reload flag either way
            sessionStorage.removeItem("isReloading");
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handlePageHide);

        resetTimer();

        return () => {
            clearTimeout(timeout);
            events.forEach((event) =>
                window.removeEventListener(event, resetSession)
            );
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
            );
            window.removeEventListener("pagehide", handlePageHide);
        };
    }, [navigate]);

    return null;
};

const SessionHandler = () => {
    useSessionTimeout();
    return null;
};

export default SessionHandler;
